import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import { Withdrawal } from '../../details'
import {
  MissingInformationWithdrawal,
  MissingInformationWithdrawalForm,
} from './types'
import { transactionRequestStatus } from '../../../const'
import { withdrawalMounted } from '../../edit/model'

export const mounted = createEvent()
export const unmounted = createEvent()
export const setMissingInformation =
  createEvent<MissingInformationWithdrawalForm>()
export const $missingInformation = restore<MissingInformationWithdrawalForm>(
  setMissingInformation,
  {
    rejectReason: '',
    inputs: '',
    missingInfoType: 0,
  },
)
export const submitMissingInformation =
  createEvent<MissingInformationWithdrawal>()
export const missingInformationTransactionRequest = fx<
  MissingInformationWithdrawal,
  Withdrawal
>({
  method: 'PUT',
  url: `/transaction_request/`,
})

sample({
  clock: submitMissingInformation,
  fn: ({
    requestId,
    rejectReason,
    missingInfoType,
    managerComment,
    managerEmail,
  }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
        ]),
      },
      body: {
        requestId: requestId,
        status: transactionRequestStatus.missingInformation(),
        rejectReason: rejectReason,
        missingInfoType: missingInfoType,
        managerComment: managerComment,
        managerEmail: managerEmail,
      },
      url: `/transaction_request/${requestId}`,
    }
  },
  target: missingInformationTransactionRequest,
})

// clear field on success

sample({
  clock: missingInformationTransactionRequest.done,
  fn: () => ({}),
  target: [withdrawalMounted],
})
